class CommonError extends Error {}

export default CommonError;
